// src/components/dialog/DlgRecalculateSensorData.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useMemo } from 'react'
import { usePagination, useTable } from 'react-table'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

const dataColumns = [
  {
    accessor: 'entity_id',
    filterAll: true,
    Header: 'entity_id',
    id: 'entity_id',
  },
  {
    accessor: 'sensor_id',
    filterAll: true,
    Header: 'Sensor ID',
    id: 'sensor_id',
  },
  {
    accessor: 'value',
    filterAll: true,
    Header: 'Wert',
    id: 'value',
  },
  {
    accessor: 'time',
    filterAll: true,
    Header: 'Zeit',
    id: 'time',
  },
  {
    accessor: 'timestamp',
    filterAll: true,
    Header: 'Zeitstempel',
    id: 'timestamp',
  },
  {
    accessor: 'timestamp_sensor',
    filterAll: true,
    Header: 'Zeitstempel Sensor',
    id: 'timestamp_sensor',
  },
]

const formatData = data => {
  const missing = data.data.missing_data.map((item, key) => ({
    ...item,
    entity_id: key + 1,
  }))

  missing.unshift(data.data.first_sensor_message)
  missing.push(data.data.second_sensor_message)

  return missing
}

type Props = KARMA_BasicDialog & {
  data: any
}

export const DlgRecalculateSensorData = ({ onClose, open, data }: Props) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    //state: { pageSize },
  } = useTable(
    {
      columns: useMemo(() => dataColumns, []),
      data: useMemo(() => formatData(data), [data]),
      initialState: { pageSize: 50 },
    },
    usePagination
  )

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={'lg'}>
      <DialogTitle>
        <Typography align={'center'}>Vorschau</Typography>
      </DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table {...getTableProps()} style={{ width: '100%' }}>
            <TableHead>
              {headerGroups.map(headerGroup => (
                <TableRow
                  key={headerGroup.id}
                  {...headerGroup.getHeaderGroupProps()}
                >
                  {headerGroup.headers.map(column => (
                    <TableCell key={column.id} {...column.getHeaderProps()}>
                      {column.render('Header')}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>

            <TableBody {...getTableBodyProps()}>
              {rows.map(row => {
                prepareRow(row)
                return (
                  <TableRow key={row.id} {...row.getRowProps()}>
                    {row.cells.map(cell => (
                      <TableCell
                        key={`${row.id}-${cell.column.id}`}
                        {...cell.getCellProps()}
                      >
                        {cell.render('Cell')}
                      </TableCell>
                    ))}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  )
}
